module.exports = __webpack_public_path__ + "assets/remove.df3d0bab.svg";